
/**
* Licensed Materials - Property of IBM
* IBM Cognos Products: ba-dashboard-core
* (C) Copyright IBM Corp. 2018, 2020
* US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
*/
define({
	'generalInfo': 'Général',
	'widgetId': 'ID widget',
	'widgetType': 'Type de widget',
	'serviceability': 'Serviçabilité',
	'copyButton': 'Copier',
	'closeButton': 'Fermer',
	'specification': 'Spécification',
	'viewSpecification': 'Afficher la spécification'
});
